module.exports = __webpack_public_path__ + "static/media/company-group.d1333a26.png";